module.exports = __webpack_public_path__ + "static/bett1ACES-768x854-v2-a579744ae17a21df09604ec3e6de2d70.mp4";